import { Avatar } from '@george-labs.com/design-system';
import classNames from 'classnames';
import type { FC } from 'react';

import type { BankMessageFlag } from './BankMessagesTypes';
import { getBankMessageIconProps } from './BankMessageIconService';

interface Props {
    flags: BankMessageFlag[] | undefined;
    className?: string;
}

export const BankMessageIcon: FC<Props> = ({ flags, className }) => {
    const iconProps = getBankMessageIconProps(flags);

    return (
        <Avatar
            icon={iconProps.icon}
            variant={Avatar.VARIANT.BORDERLESS}
            color={iconProps.color}
            backgroundColor={iconProps.backgroundColor}
            className={classNames('mr-3', className)}
            aria-label={iconProps.label}
            data-cy={iconProps.dataCy}
        />
    );
};
